import { Button } from '@ets-global/b2c-website-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { paths } from '../../paths';
import UploadCandidatePictureBase from './Base';

const UploadCandidatePictureSuccess = ({ withActions = false }) => {
  const { t } = useTranslation();
  const actions = withActions ? (
    <Button to={paths.HOME} aria-label={t('upload-candidate-picture.success.link-go-to-site')}>
      <Trans>upload-candidate-picture.success.link-go-to-site</Trans>
    </Button>
  ) : (
    ''
  );

  return (
    <UploadCandidatePictureBase title={t('upload-candidate-picture.success.title')} actions={actions}>
      <p className={'upload-candidate-picture__success'}>
        <Trans>upload-candidate-picture.success.message</Trans>
      </p>
    </UploadCandidatePictureBase>
  );
};

export default UploadCandidatePictureSuccess;
